<template>
    <div class="sidebar" :class="showMenu ? 'extendMenu' : null">
        <h1>
            <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px">
                    <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                          d="M18.000,24.000 L18.000,-0.000 L24.000,-0.000 L24.000,24.000 L18.000,24.000 ZM9.000,12.000 L15.000,12.000 L15.000,24.000 L9.000,24.000 L9.000,12.000 ZM-0.000,18.000 L6.000,18.000 L6.000,24.000 L-0.000,24.000 L-0.000,18.000 Z">
                    </path>
                </svg>
            </i>
            <div> Portal<span>Analytics</span> </div>
        </h1>
        <div class="box-expand">
            <i @click="changeMenu" :class="showMenu ? 'icon-left-open' : 'icon-right-open'"></i>
        </div>

        <c-tooglemenu></c-tooglemenu>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showMenu: true,
            }
        },
        methods:{
            changeMenu(){
                this.showMenu = !this.showMenu;
                $('body').toggleClass('menu-fechado');
            }
        },
    }
</script>